/**
 * The stable id the extraction pipeline and title templates use.
 *
 * Derived from the human label while an attribute is new, then frozen on save —
 * renaming the label must never silently break a title template referencing it.
 */
export function deriveAttributeKey(label: string): string {
  const ascii = label
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase();
  const slug = ascii.replace(/[^a-z0-9]+/g, "_").replace(/^_+|_+$/g, "");
  if (!slug) return "";
  return /^[0-9]/.test(slug) ? `a${slug}` : slug;
}

export function isValidAttributeKey(key: string): boolean {
  return /^[a-z][a-z0-9_]*$/.test(key);
}
